import { CreateBusinessDto } from '@40seas/entities/businesses';
import { Omit, WithEffect } from '@40seas/entities/common';

export class CreateBuyerDto extends WithEffect(Omit(CreateBusinessDto, ['types']), {
    check: (data) => !!(data.displayName || data.legalName),
    message: {
        message: 'Either displayName or legalName must be provided',
        path: ['displayName', 'legalName'],
    },
}) {}
